import { Chip, Divider, EChipSizeVariant, LinkButton } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import { IHeaderSearchFilterDates } from '@/redux/modules/globalHeader';

interface IDateContentFooterProps {
  datesValue?: IHeaderSearchFilterDates;
  handleChangeDates: (newDates: IHeaderSearchFilterDates) => void;
  handleClearDates: () => void;
}

const DateContentFooter: React.FC<IDateContentFooterProps> = ({
  datesValue,
  handleChangeDates,
  handleClearDates,
}) => {
  const intl = useIntl();
  return (
    <>
      <Divider className="mt-2 mb-3" />
      <div className="flex items-center justify-between gap-10">
        <LinkButton
          label={intl.formatMessage({ defaultMessage: 'Clear', id: '/GCoTA' })}
          onClick={handleClearDates}
        />
        <div className="flex gap-2">
          <Chip
            content={intl.formatMessage({ defaultMessage: 'Match exact dates', id: 'uhcpp1' })}
            sizeVariant={EChipSizeVariant.Small}
            onClick={() => handleChangeDates({ flexible_days: undefined })}
            active={!datesValue?.flexible_days}
            withBoxShadow={false}
            contentClassName="whitespace-nowrap [&>p]:font-medium"
          />
          <Chip
            content={intl.formatMessage({ defaultMessage: '± 1 day', id: '9IdT1V' })}
            sizeVariant={EChipSizeVariant.Small}
            onClick={() => handleChangeDates({ flexible_days: 1 })}
            active={datesValue?.flexible_days === 1}
            withBoxShadow={false}
            contentClassName="whitespace-nowrap [&>p]:font-medium"
          />
          <Chip
            content={intl.formatMessage({ defaultMessage: '± 3 days', id: 'r4uykC' })}
            sizeVariant={EChipSizeVariant.Small}
            onClick={() => handleChangeDates({ flexible_days: 3 })}
            active={datesValue?.flexible_days === 3}
            withBoxShadow={false}
            contentClassName="whitespace-nowrap [&>p]:font-medium"
          />
        </div>
      </div>
    </>
  );
};

export default DateContentFooter;
